import { ContentStyle, errors, ErrorType } from '../content';

export interface AlertElProps {
  titleId: string;
  message: React.ReactNode;
  rightActions: React.ReactNode[];
}

export const getAlertFromKey = ({
  contentStyle,
  errorKey,
  jobId,
}: {
  contentStyle: ContentStyle;
  errorKey?: ErrorType;
  jobId?: string;
}): AlertElProps => {
  if (!errors[contentStyle]) return errors[ContentStyle.SELLER_CENTRAL](jobId).DEFAULT;
  if (!errorKey) return errors[contentStyle](jobId).DEFAULT;

  const errorObj = errors[contentStyle](jobId);
  const specificError = errorObj[errorKey as keyof typeof errorObj];
  if (specificError) return specificError;
  return errorObj.DEFAULT;
};
